// @ts-nocheck
/**
 * BRINUTI — ESEMÉNYRÉTEG (C0)
 *
 * Az újratervezési doksi 1. prioritása, és jó okkal: a Clarity eredeti
 * exportjában 1 561 munkamenetből NULLA tartalmazott kosár- vagy
 * checkout-URL-t. A tölcsér a termékoldalnál megállt, tehát a következő
 * körben megint csak annyit látnánk, hogy „valaki sokat kattintott".
 *
 * Amit küldünk (a doksi C0 elfogadási feltétele):
 *   personalization_start · add_to_cart · cart_open · cart_upsell_add ·
 *   checkout_click · similar_rail_click · load_more_click
 *
 * Hova küldjük:
 *   - Microsoft Clarity (`clarity('event', nev)`) — ott lesz szűrhető
 *     dimenzió a felvételekhez;
 *   - `window.dataLayer` — ha valaha bekerül a GTM, már ott van az adat.
 *
 * Amit NEM csinál: nem küld személyes adatot, nem tesz sütit, és nem vár
 * semmilyen külső szkriptre. Ha a Clarity nincs betöltve, csendben kimarad.
 */
(function () {
  'use strict';

  /** Amit már elküldtünk ezen az oldalbetöltésen — egyszer elég belőle. */
  const egyszeri = {};

  /**
   * @param {string} nev - az esemény neve
   * @param {object} [adat] - kiegészítő mezők (termék, kategória)
   * @param {boolean} [csakEgyszer]
   */
  function kuld(nev, adat, csakEgyszer) {
    if (csakEgyszer) {
      if (egyszeri[nev]) return;
      egyszeri[nev] = true;
    }

    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', nev);
        // A Clarity egyedi címkéi külön hívással mennek, és csak stringet
        // fogadnak el. Csak akkor küldjük, ha van mit.
        if (adat) {
          Object.keys(adat).forEach(function (kulcs) {
            if (adat[kulcs]) window.clarity('set', kulcs, String(adat[kulcs]));
          });
        }
      }
    } catch (e) {
      /* A mérés soha nem törheti el a boltot. */
    }

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: nev }, adat || {}));
    } catch (e) {
      /* ugyanaz */
    }
  }

  window.brinutiEsemeny = kuld;

  /* ------------------------------------------------------------------ */
  /* Kattintás-alapú események                                           */
  /* ------------------------------------------------------------------ */

  document.addEventListener(
    'click',
    function (e) {
      const cel = e.target;
      if (!cel || !cel.closest) return;

      // Saját jelöléssel ellátott elemek (hasonló borítók, chipek, menü)
      const sajat = cel.closest('[data-brinuti-esemeny]');
      if (sajat) {
        const tipus = sajat.getAttribute('data-brinuti-esemeny');
        const adat = {
          brinuti_termek: sajat.getAttribute('data-brinuti-termek') || '',
          brinuti_kategoria: sajat.getAttribute('data-brinuti-kategoria') || ''
        };

        if (tipus === 'hasonlo_borito') {
          kuld('similar_rail_click', adat);
        } else if (tipus === 'kosar_meg_egy_naplo') {
          kuld('cart_second_journal_click', adat);
        } else {
          kuld(tipus, adat);
        }
      }

      // Betöltés gomb
      if (cel.closest('.brinuti-tovabbi-gomb')) {
        kuld('load_more_click');
      }

      // Pénztár — a téma és az upsell ablak gombjai is ide esnek
      const penztar = cel.closest('[name="checkout"], a[href*="/checkout"], [href$="/checkout"]');
      if (penztar) {
        kuld('checkout_click');
      }
    },
    true
  );

  /* ------------------------------------------------------------------ */
  /* Személyre szabás kezdete                                            */
  /* ------------------------------------------------------------------ */

  /* Az első érdemi interakció a Teeinblue űrlapon. Ez a doksi legfontosabb
     hiányzó mérőszáma: ma nem tudjuk megkülönböztetni azt, aki elkezdte a
     konfigurálást, attól, aki csak ránézett az oldalra.

     Fókuszra ÉS kattintásra is figyelünk: a színválasztó nem fókuszálható
     mező, a névbeírás viszont igen. */
  function teeinblueE(elem) {
    if (!elem || !elem.closest) return false;
    return !!elem.closest('[class*="tee-"], [id*="teeinblue"], .tee-block');
  }

  ['focusin', 'click', 'change'].forEach(function (esemenyNev) {
    document.addEventListener(
      esemenyNev,
      function (e) {
        if (teeinblueE(e.target)) {
          kuld('personalization_start', null, true);
        }
      },
      true
    );
  });

  /* ------------------------------------------------------------------ */
  /* Kosár: hozzáadás, megnyitás, upsell                                 */
  /* ------------------------------------------------------------------ */

  /* A kosárba tételt a hálózati hívásból olvassuk ki, nem gombfeliratból:
     a naplókat a Teeinblue teszi be, a kiegészítőket a téma, az upsell
     ablak pedig megint máshogy — közös pont csak a /cart/add kérés. */
  const eredetiFetch = window.fetch;
  if (typeof eredetiFetch === 'function') {
    window.fetch = function (bemenet, opciok) {
      let cim = '';
      try {
        cim = typeof bemenet === 'string' ? bemenet : (bemenet && bemenet.url) || '';
      } catch (e) {
        cim = '';
      }

      const valasz = eredetiFetch.apply(this, arguments);

      if (cim && cim.indexOf('/cart/add') !== -1) {
        valasz
          .then(function (v) {
            if (v && v.ok) {
              // Az upsell ablakból érkező hozzáadás külön esemény: a doksi
              // az attach rate-et és a checkout-továbbjutást együtt nézi.
              //
              // LÁTHATÓSÁGOT nézünk, nem puszta meglétet: az upsell ablak
              // jelölése minden termékoldalon ott van a DOM-ban, elrejtve.
              // Mérve: enélkül a sima „kosárba" is upsell-hozzáadásnak
              // számított volna.
              //
              // Az is-active osztályt nézzük, nem az offsetParent-et: az ablak
              // position: fixed, arra az offsetParent MINDIG null, tehát a
              // régi vizsgálat sosem látta nyitva (2026-09-18).
              const upsellNyitva = !!document.querySelector('.brinuti-interstitial.is-active');
              kuld(upsellNyitva ? 'cart_upsell_add' : 'add_to_cart');
            }
          })
          .catch(function () {
            /* a hívó dolga */
          });
      }

      return valasz;
    };
  }

  /* Kosárfiók megnyílása. A téma natív <dialog>-ot használ, tehát az `open`
     attribútum megjelenése a megbízható jel — nem a gombkattintás, mert a
     fiók magától is kinyílik kosárba tétel után. */
  function figyeldAFiokot() {
    const fiok = document.querySelector('cart-drawer-component, dialog.cart-drawer, .cart-drawer');
    if (!fiok) return false;

    new MutationObserver(function () {
      const nyitva = fiok.hasAttribute('open') || fiok.querySelector('[open]');
      if (nyitva) kuld('cart_open');
    }).observe(fiok, { attributes: true, attributeFilter: ['open'], subtree: true });

    return true;
  }

  if (!figyeldAFiokot()) {
    document.addEventListener('DOMContentLoaded', figyeldAFiokot);
  }

  /* Hozzájárulás-címke a Clarityben. Az EU-s látogató, aki nem fogadja el a
     sütibannert (vagy nem kattint rá), cookie nélkül kerül rögzítésre: nála
     minden oldalbetöltés külön munkamenet, így a termékoldal → kosár út nem
     látszik egyben. A címkével a Clarityben szűrni lehet: „hozzajarulas =
     igen" munkamenetek egész utak, a „nem" / „nincs-dontes" munkamenetek
     egyoldalas töredékek. Nem személyes adat, sütit nem tesz. */
  function hozzajarulasCimke(engedve) {
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('set', 'hozzajarulas', engedve);
      }
    } catch (e) {
      /* A mérés soha nem törheti el a boltot. */
    }
  }

  function kezdoHozzajarulas() {
    const cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return false;
    let allapot = cp.analyticsProcessingAllowed() ? 'igen' : 'nem';
    // Ha a banner még kint van, a látogató nem döntött (EU-ban ez „nem"-ként fut).
    if (allapot === 'nem' && typeof cp.currentVisitorConsent === 'function') {
      const c = cp.currentVisitorConsent() || {};
      if (!c.analytics) allapot = 'nincs-dontes';
    }
    hozzajarulasCimke(allapot);
    return true;
  }

  document.addEventListener('visitorConsentCollected', function (e) {
    hozzajarulasCimke(e.detail && e.detail.analyticsAllowed ? 'igen' : 'nem');
  });

  // A consent-tracking-api későn töltődik; pár másodpercig próbálkozunk.
  let probak = 0;
  (function varj() {
    if (kezdoHozzajarulas() || ++probak > 20) return;
    setTimeout(varj, 500);
  })();
})();
